// lib/emails/rueckmeldung.ts
// #551: „Rückmeldung?“ — Mail wartet auf eine Antwort. Etikett mit Wartezeit; ab RUECKMELDUNG_TAGE auffällig.

export const RUECKMELDUNG_TAGE = 7;

/** Ganze Tage seit dem Markieren (lokaler Kalender). */
export function tageSeit(seitIso: string, jetzt: Date): number {
  const a = new Date(seitIso); a.setHours(0, 0, 0, 0);
  const b = new Date(jetzt); b.setHours(0, 0, 0, 0);
  return Math.max(0, Math.round((b.getTime() - a.getTime()) / 86400000));
}

/** Etikett-Text und ob die Wartezeit überschritten ist. */
export function rueckmeldungEtikett(seitIso: string | null | undefined, jetzt: Date): { label: string; ueberfaellig: boolean } | null {
  if (!seitIso) return null;
  const t = tageSeit(seitIso, jetzt);
  const label = t === 0 ? 'Rückmeldung? · seit heute' : t === 1 ? 'Rückmeldung? · seit gestern' : `Rückmeldung? · seit ${t} Tagen`;
  return { label, ueberfaellig: t >= RUECKMELDUNG_TAGE };
}
